import React from 'react';
import { GraduationCap, Award, BookOpen, Trophy } from 'lucide-react';
import { education } from '../data/mockData';
import '../styles/EducationSection.css';

const EducationSection = () => {
  const iconMap = {
    fellowship: Award,
    specialization: Trophy,
    postgraduate: GraduationCap,
    undergraduate: BookOpen
  };

  return (
    <section className="education-section">
      <div className="education-container">
        <div className="section-header">
          <div className="section-label">Academic Excellence</div>
          <h2 className="section-title">Education & Credentials</h2>
        </div>
        
        <div className="education-grid">
          {education.map((edu, index) => {
            const Icon = iconMap[edu.type];
            return (
              <div key={index} className="education-card">
                <div className="edu-icon-badge">
                  <Icon size={24} />
                </div>
                <div className="edu-content">
                  <h3 className="edu-degree">{edu.degree}</h3>
                  <p className="edu-institution">{edu.institution}</p>
                  <div className="edu-year">{edu.year}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EducationSection;
